import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id BA5FCCBE-ED06-4819-B2F3-532034AB09BB
 * name tab-minus
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tab-minus.svg
 * tags
 */
export const TabMinusIcon = createSvgIcon(<><path d="M3,3A2,2 0 0,0 1,5V19A2,2 0 0,0 3,21H21A2,2 0 0,0 23,19V5A2,2 0 0,0 21,3H3M3,5H13V9H21V19H3V5M7,13V15H15V13H7Z" /></>, 'TabMinusIcon');
export default TabMinusIcon